import { Controller } from "@hotwired/stimulus";
import "./component.scss"

export default class extends Controller {
  static targets = ["slot"]

  get activeSlotClass() {
    return "c-appointments_picker-slot--active"
  }

  connect() {
  }

  setSelected(event) {
    const slot = event.currentTarget;

    this.slotTargets.forEach(s => {
      s.classList.remove(this.activeSlotClass)
    })

    slot.classList.add(this.activeSlotClass);
  }
}
